import { FC } from "react";

// * Components
import Icon from "../../Icon";

// * Hooks
import { useGetUserQuery } from "../../../features/api/apiSlice";

// * Data
import { admin } from "./HeaderAdmin.data";

//* Styles
import styles from './HeaderAdmin.module.css';

const HeaderAdmin: FC = () => {
  const { data: user } = useGetUserQuery();

  const filteredAdminLinks = user?.admin ? admin : [];

  if (filteredAdminLinks.length === 0) {
    return null;
  }

  return (
    <div className={styles.admin}>
      {filteredAdminLinks.map((adminItem) => (
        <a
          href={adminItem.link}
          key={adminItem.link}
          target="_BLANK"
          rel="noreferrer"
        >
          <Icon name={adminItem.icon} />
        </a>
      ))}
    </div>
  );
};

export default HeaderAdmin;